import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  input,
  output,
  viewChildren,
} from '@angular/core';
import { SecurityMarketDetails } from '@pinnakl/securities/domain';
import { SecuritySearchResult } from '@pinnakl/shared/types';
import { SearchSecurityItem } from './security-item.model';
import { addAlpha, getCurrentSymbol, mapSecuritiesData } from './security-item.util';
import { SecurityItemComponent } from './security-item/security-item.component';

@Component({
  selector: 'pnkl-security-items',
  templateUrl: './security-items.component.html',
  styleUrls: ['./security-items.component.scss'],
  imports: [SecurityItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityItemsComponent {
  private _items: SearchSecurityItem[];
  readonly securityItems = viewChildren('securityItem', { read: ElementRef });
  activeItemIndex = -1;
  getCurrentSymbol = getCurrentSymbol;
  addAlpha = addAlpha;
  readonly searchText = input('');
  readonly itemClicked = output<SearchSecurityItem>();

  get items(): SearchSecurityItem[] {
    return this._items;
  }

  @Input() set items(v: SecuritySearchResult[] | SecurityMarketDetails[]) {
    this._items = mapSecuritiesData(v);
  }

  @HostListener('document:keydown', ['$event'])
  arrowKeysHandler(event: KeyboardEvent): void {
    const keypressHandlers = {
      ArrowDown: () => {
        const nextElementIndex = ++this.activeItemIndex > this.securityItems().length - 1 ? 0 : this.activeItemIndex;

        this.securityItems().at(nextElementIndex).nativeElement.focus();
        this.activeItemIndex = nextElementIndex;
      },
      ArrowUp: () => {
        const nextElementIndex = --this.activeItemIndex < 0 ? this.securityItems().length - 1 : this.activeItemIndex;

        this.securityItems().at(nextElementIndex).nativeElement.focus();
        this.activeItemIndex = nextElementIndex;
      },
      Enter: () => {
        const eventType = this.activeItemIndex >= 0 ? 'Select' : 'ArrowDown';

        keypressHandlers[eventType]();
      },
      Select: () => {
        const selectedItem = this.items[this.activeItemIndex];

        this.itemSelected(selectedItem);
      },
    };

    if (keypressHandlers[event.key]) {
      keypressHandlers[event.key]();
    }
  }

  resetIndexOnBlur(): void {
    this.activeItemIndex = -1;
  }

  itemSelected(item: SearchSecurityItem): void {
    this.itemClicked.emit(item);
  }
}
